<template>
  <div class="cinemas-list-page">
    <!-- 顶部搜索栏 -->
    <div class="cinemas-search-bar">
      <SearchHeader
        v-model="searchName"
        :show-back="false"
        clearable
        placeholder="搜索影院名称"
        variant="plain"
        @search="onSearch"
        @clear="onClear"
      />
    </div>

    <!-- 影院列表 -->
    <div class="list-container">
      <van-list 
        v-if="cinemaList.length > 0" 
        v-model="loading" 
        :finished="finished" 
        finished-text="没有更多了" 
        @load="onLoadMore">
        <cinema-item :list="cinemaList" />
      </van-list>
      
      <!-- 空状态 -->
      <div v-else-if="!loading && dataLoaded" class="empty-state">
        <div class="empty-icon">🏢</div>
        <div class="empty-text">{{ searchName ? '未找到相关影院' : '当前城市暂无影院' }}</div>
      </div>
    </div>

    <!-- 底部导航 -->
    <MovieNav />
  </div>
</template>

<script>
import CinemaItem from "../../components/movie/CinemaItem.vue";
import MovieNav from "../../components/footnav/MovieNav.vue";
import SearchHeader from "../../components/goodlist/SearchHeader.vue";

export default {
  name: 'CinemasList',
  components: { CinemaItem, MovieNav, SearchHeader },
  data() {
    return {
      searchName: '',
      cinemaList: [],
      loading: false,
      finished: false,
      dataLoaded: false,
      queryParams: {
        cardId: '',
        cityCode: '',
        current: 1,
        size: 10,
        lat: null,
        lng: null,
        cinemaName: '',
      },
    }
  },
  methods: {
    // 初始化参数
    initParams() {
      this.queryParams.cardId = localStorage.getItem("cardId");
      this.queryParams.cityCode = localStorage.getItem('cityCode');
      this.queryParams.lat = localStorage.getItem('latitude');
      this.queryParams.lng = localStorage.getItem('longitude');
    },
    
    // 搜索
    onSearch() {
      this.queryParams.cinemaName = this.searchName;
      this.queryParams.current = 1;
      this.cinemaList = [];
      this.finished = false;
      this.dataLoaded = false;
      this.queryCinemas();
    },
    
    // 清除搜索
    onClear() {
      this.searchName = '';
      this.onSearch();
    },
    
    // 加载更多
    onLoadMore() {
      // van-list 已经处理了 loading 状态，这里只需检查是否已加载完
      if (this.finished) return;
      this.queryParams.current++;

      this.queryCinemas();
    },
    
    // 查询影院列表
    queryCinemas() {
      this.loading = true;
      this.$api
        .queryCinemas(this.queryParams)
        .then((res) => {
          this.loading = false;
          this.dataLoaded = true;
          
          if (res.code == 1) {
            this.$Toast(res.msg);
            this.finished = true;
            return;
          }
          
          const records = res.data?.records || [];
          
          // 第一页替换，后续页追加
          if (this.queryParams.current === 1) {
            this.cinemaList = records;
          } else {
            this.cinemaList.push(...records);
          }
          
          // 判断是否还有更多数据
          if (records.length < this.queryParams.size) {
            this.finished = true;
          }
          

        })
        .catch((err) => {
          this.loading = false;
          this.dataLoaded = true;
          this.finished = true;
          console.error('CinemasList 查询失败:', err);
        });
    },
    
    // 刷新列表
    refreshList() {
      this.searchName = '';
      this.queryParams.cinemaName = '';
      this.queryParams.current = 1;
      this.cinemaList = [];
      this.finished = false;
      this.dataLoaded = false;
      this.queryCinemas();
    }
  },
  
  mounted() {
    // 初始化由 beforeRouteEnter 处理
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initParams();
      vm.refreshList();
    });
  }
}
</script>

<style lang="scss" scoped>
.cinemas-list-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.cinemas-search-bar {
  position: sticky;
  top: 0;
  z-index: 100;
}

.list-container {
  flex: 1;
  padding: 0.8rem;
  padding-bottom: 5rem;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 1rem;
  text-align: center;
  
  .empty-icon {
    font-size: 3.5rem;
    margin-bottom: 1.2rem;
    opacity: 0.5;
  }
  
  .empty-text {
    color: #999;
    font-size: 1rem;
  }
}
</style>